import { apiService } from '../../..'
import { OrderChannel } from '../../ordertransactions/types'

const baseUrl = '/portal/consumers/payment-routing'

type keys = keyof typeof OrderChannel

export type Routing = {
  [key in keys]: string
}
export interface PaymentRoutingResponse {
  url: string
  routing: Routing
}

export const paymentRoutingService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getPaymentRouting: build.query<PaymentRoutingResponse, void>({
      query: () => {
        return {
          url: baseUrl,
          method: 'GET',
        }
      },
    }),
  }),
})
